var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("BreaksConfirmation", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "p",
              {
                directives: [
                  {
                    name: "jest",
                    rawName: "v-jest",
                    value: "meal-break-rejected-header",
                    expression: "'meal-break-rejected-header'",
                  },
                ],
              },
              [_vm._v("\n\t\t\tMeal break request\n\t\t")]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "bodyIcon",
        fn: function () {
          return [
            _c("OrigamiIcon", {
              staticClass: "tw-text-origami-red-400",
              attrs: { name: "block", width: "32", height: "32" },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "bodyText",
        fn: function () {
          return [
            _vm.formattedBreakRequestTimes
              ? _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "jest",
                        rawName: "v-jest",
                        value: "meal-break-rejected-details",
                        expression: "'meal-break-rejected-details'",
                      },
                    ],
                  },
                  [
                    _vm._v(
                      "\n\t\t\tYour break has been rejected for " +
                        _vm._s(_vm.formattedBreakRequestTimes.startTime) +
                        " - " +
                        _vm._s(_vm.formattedBreakRequestTimes.endTime) +
                        "\n\t\t"
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "buttons",
        fn: function () {
          return [
            _c(
              "OrigamiButton",
              {
                directives: [
                  {
                    name: "jest",
                    rawName: "v-jest",
                    value: "meal-break-rejected-try-again-button",
                    expression: "'meal-break-rejected-try-again-button'",
                  },
                ],
                staticClass: "tw-w-full tw-justify-center",
                attrs: { variant: "primary", "is-loading": _vm.isLoading },
                nativeOn: {
                  click: function ($event) {
                    return _vm.requestBreak.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n\t\t\tTry for another time\n\t\t")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }